/**
 * RefluxBrief — iter1060 — компактна сводка от кратката проверка за рефлукс,
 * показана в гастро/микробиомния близнак. Рендира се само при налични
 * данни, за да не добавя шум.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { ArrowRight, Flame } from "lucide-react";

const TONE = {
  likely: { light: "bg-amber-50 border-amber-300", dark: "bg-amber-900/25 border-amber-500/40" },
  possible: { light: "bg-sky-50 border-sky-200", dark: "bg-sky-900/20 border-sky-500/30" },
  unlikely: { light: "bg-emerald-50 border-emerald-200", dark: "bg-emerald-900/20 border-emerald-500/30" },
};

export const RefluxBrief = ({ isDark }) => {
  const { API } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => {
    axios.get(`${API}/reflux/brief`).then(({ data }) => setD(data)).catch(() => setD(null));
  }, [API]);

  if (!d?.has_data) return null;
  const t = TONE[d.level] || TONE.unlikely;

  return (
    <button onClick={() => navigate(d.route)} data-testid="reflux-brief"
            className={`w-full text-left p-3 rounded-xl border ${isDark ? t.dark : t.light}`}>
      <div className="flex items-center gap-1.5">
        <Flame className="w-3.5 h-3.5 text-amber-500" />
        <span className="text-[11px] font-bold flex-1" data-testid="reflux-brief-label">{d.label_bg}</span>
        <span className="text-[10px] opacity-60 tabular-nums">{d.score} т.</span>
        <ArrowRight className="w-3 h-3 opacity-50" />
      </div>
      <div className="text-[10px] opacity-80 mt-0.5 leading-relaxed">
        Кратката проверка за рефлукс стои тук, защото е един и същ въпрос с
        абсорбцията: киселината е първата стъпка на усвояването, а
        киселинният блокер е най-честата причина за нисък B12, желязо,
        калций и магнезий без дефицит в храната.
      </div>
      {d.cardiac_flag && (
        <div className="text-[10px] font-bold text-rose-500 mt-1" data-testid="reflux-brief-cardiac">
          Има отбелязан сърдечен предупредителен признак — това се изключва първо.
        </div>
      )}
      {d.alarm_flag && (
        <div className="text-[10px] font-bold text-rose-500 mt-1" data-testid="reflux-brief-alarm">
          Има тревожен признак, който налага гастроскопия.
        </div>
      )}
    </button>
  );
};

export default RefluxBrief;
